export const analysisAreaTypes = [
  {
    label: '05 - Electrical energy',
    id: '05'
  },
  {
    label: '06 - Fuels',
    id: '06'
  },
  {
    label: '07 - Other Auxiliary',
    id: '07'
  },
  {
    label: '10 - Quarry',
    id: '10'
  },
  {
    label: '20 - Crushing and Raw Material Handling',
    id: '20'
  },
  {
    label: '30 - Raw Material Preparation',
    id: '30'
  },
  {
    label: '40 - Clinker Production',
    id: '40'
  },
  {
    label: '50 - Cement Grinding',
    id: '50'
  },
  {
    label: '60 - Packing and Loading',
    id: '60'
  }
]

export const analysisCategories = [
  {
    label: 'Health & Safety',
    id: 'HealthAndSafety'
  },
  {
    label: 'Quality',
    id: 'Quality'
  },
  {
    label: 'Environment',
    id: 'Environment'
  },
  {
    label: 'Production',
    id: 'Production'
  },
  {
    label: 'Process',
    id: 'Process'
  }
] as const
export const rootCauseTypes = [
  'inspection',
  'material',
  'people',
  'environment',
  'method',
  'equipment',
  'other'
] as const
